import React, { useContext } from 'react'
import Price from "app/React/Components/Footer/Price";
import DepositField from "app/React/Components/Footer/DepositField";
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";
import classNames from 'classnames'

function FooterPrice() {
  const {
    currentVariant,
    isAccessoryShop,
    hideSecurityDeposit,
    isGlobalDownPaymentCash,
    isGlobalDownPaymentLeasing,
    order,
    strings,
  } = useContext(ConfiguratorContext)

  const footerStrings = strings.footer ?? {}
  const showPrice = Boolean(Number(currentVariant.show_price))

  const isGlobalDownPayment =
    (order.paymentType === 'cash' && isGlobalDownPaymentCash) ||
    (order.paymentType === 'leasing' && isGlobalDownPaymentLeasing)

  if (!showPrice) {
    return null
  }

  if (isAccessoryShop) {
    return <DepositField/>
  }

  return (
    <div className={classNames('config-overview-bar__price_field', {
      'no-security-deposit': hideSecurityDeposit,
    })}>
      <div className='config-overview-bar__field-title'>
        <Price/>
      </div>
      <div className='config-overview-bar__field-text'>
        {!hideSecurityDeposit && (
          <>
            <DepositField/>
            &nbsp;
            {
              isGlobalDownPayment
                ? <span>{footerStrings.in_security_deposit}</span>
                : <span>{order.paymentType === 'cash' ? footerStrings.in_security_deposit : footerStrings.in_security_deposit_leasing}</span>
            }
          </>
        )}
      </div>
    </div>
  )
}

export default FooterPrice
